<template>
  <v-container>
    <ValidationObserver ref="form">
      <FormToolbar
        :title="edit ? 'Edit Bulk' : 'New Bulk'"
        :onSubmitClick="submitForm"
        :onCloseClick="onCloseClick"
      />
      <v-form class="mt-1" @keyup.enter.native="submitForm">
        <v-container>
          <v-row>
            <v-col cols="12" sm="8">
              <ValidationProvider
                name="Bulk Name"
                rules="required|max:50"
                v-slot="{ errors }"
              >
                <v-text-field
                  ref="firstInput"
                  v-model="entity.bulkName"
                  :error-messages="errors"
                  label="Bulk Name"
                  :counter="50"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="8">
              <ValidationProvider
                name="Bulk Type"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  v-model="entity.bulkType"
                  :items="getBulkTypes"
                  item-text="value"
                  item-value="value"
                  :error-messages="errors"
                  label="Bulk Type"
                ></v-select>
              </ValidationProvider>
            </v-col>
            <v-checkbox
              v-if="edit"
              v-model="entity.isActive"
              label="Active"
            ></v-checkbox>
          </v-row>
        </v-container>
      </v-form>
    </ValidationObserver>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import FormToolbar from '../ui/FormToolbar.vue';
import '../../validators';

export default {
  props: {
    edit: Boolean,
    entity: Object,
    onSubmitClick: Function,
    onCloseClick: Function,
    bus: Object,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    FormToolbar,
  },
  computed: {
    ...mapGetters({
      getBulkTypes: 'bulksStore/getBulkTypes',
    }),
  },
  created() {
    this.$store.dispatch('bulksStore/loadBulkTypes');
  },
  mounted() {
    this.bus.$on('resetForm', this.resetForm);
  },
  methods: {
    submitForm() {
      this.$refs.form.validate()
        .then((isValid) => {
          if (isValid) this.onSubmitClick();
        });
    },
    resetForm() {
      this.$nextTick(() => this.$refs.firstInput.focus());
      this.$refs.form.reset();
    },
  },
};
</script>
